module.exports = __webpack_public_path__ + "static/pin-matcher-ce9e76ba9d03bf1159e6bd4de11e5d2a.gif";